var _defs, _path, _circle, _circle2, _circle3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.752,
    height: 18.623,
    viewBox: "0 0 26.752 18.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#007c9f;}.b{fill:#0eb4d0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3616.854-2698.386h-21.223a1.267,1.267,0,0,0-.153-.044,2.905,2.905,0,0,1-2.609-3.056q0-6.231.007-12.462a3.575,3.575,0,0,1,.171-1.1,2.9,2.9,0,0,1,2.935-1.958q6.958,0,13.917,0c2.218,0,4.435,0,6.653,0a2.933,2.933,0,0,1,2.912,2c.06.181.1.368.155.553v13.5c-.02.06-.045.119-.06.18a2.884,2.884,0,0,1-2.236,2.3C3617.17-2698.438,3617.011-2698.417,3616.854-2698.386Zm-22.824-11.627v.349q0,4.079,0,8.158a1.759,1.759,0,0,0,1.932,1.935q10.285,0,20.57,0a1.754,1.754,0,0,0,1.923-1.911q0-4.095,0-8.19v-.34Zm24.409-2.927c0-.478.026-.927-.007-1.373a1.607,1.607,0,0,0-.611-1.127,1.956,1.956,0,0,0-1.321-.4q-10.254.005-20.508,0a3.21,3.21,0,0,0-.417.02,1.555,1.555,0,0,0-1.426,1.163,10.5,10.5,0,0,0-.159,1.715Z",
    transform: "translate(-3592.868 2717.009)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.151,
    cy: 1.151,
    r: 1.151,
    transform: "translate(13.695 13.665)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.151,
    cy: 1.151,
    r: 1.151,
    transform: "translate(17.267 13.665)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.151,
    cy: 1.151,
    r: 1.151,
    transform: "translate(21.15 13.665)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.221,
    height: 1.3,
    rx: 0.65,
    transform: "translate(3.707 8.52)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPaymentMethod);
export default __webpack_public_path__ + "static/media/icn-payment-method.52abca4e610ba5df9a37a1d7d08fe50b.svg";
export { ForwardRef as ReactComponent };